<template>
  <div>
    <button class="nav-link btn btn-outline-secondary btn-sm mx-md-3" @click="turnInstructor">Virar Instrutor</button>
  </div>
</template>

<script>
import Swal from 'sweetalert2'
import Axios from 'axios'
import { mapGetters } from 'vuex'

export default {
  computed: {
    ...mapGetters({
      user: 'getCurrentUser'
    })
  },
  methods:{
    turnInstructor: function () {
      let queue = Swal.mixin({
        input: 'text',
        confirmButtonText: 'Proximo',
        showCancelButton: true,
        backdrop: '#CC3300',
        cancelButtonColor: '#d33',
        progressSteps: ['1', '2', '3']
      }).queue([
        {
          title: 'Documento',
          text: 'Fala pra gente o seu CPF ou CNPJ.',
          inputValue: this.user.document,
          preConfirm: ( value ) => {
            let document = value.replace(/[^\d]+/g,'')

            if ( document.length != 11 && document.length != 14 ) {
              Swal.showValidationMessage(
                `O numero ${ value } é inválido, lembre-se use apenas números`
              )
            }

            if (document.length == 14) {
              Swal.insertQueueStep({
                title: 'Responsavel da Empresa',
                text: 'Dados do responsavel da Empresa.',
                input: null,
                html: `
                  <div class="col-12 input-group input-group-sm">
                    <span class="input-group-prepend w-25">
                      <span class="input-group-text w-100">Nome</span>
                    </span>
                    <input class="form-control form-control-sm" name="resp_name" />
                  </div>
                  <div class="col-12 input-group input-group-sm">
                    <span class="input-group-prepend w-25">
                      <span class="input-group-text w-100">CPF</span>
                    </span>
                    <input class="form-control form-control-sm" name="resp_cpf" />
                  </div>
                `,
                preConfirm: ( value ) => {
                  let resp = {}
                  resp.resp_name = $('input[name=resp_name]').val()
                  resp.resp_cpf = $('input[name=resp_cpf]').val()

                  if (resp.resp_name == "" || resp.resp_cpf == "") {
                    Swal.showValidationMessage(
                      `Alguma coisa esta errada nos dados do responsavel`
                    )
                  } else {
                    return resp
                  }
                }
              }, '4')
            }

            return document
          }
        },
        {
          title: 'Biografia',
          text: 'A gente quer saber um pouco mais sobre você.',
          input: 'textarea',
          inputValue: this.user.bio,
          preConfirm: ( value ) => {
            if ( value.length < 20 ) {
              Swal.showValidationMessage(
                `A sua biografia precisa de no minimo 20 caracteres`
              )
            }
          }
        },
        {
          title: 'Dados Bacários',
          text: 'Precisamos dos dados da sua conta.',
          input: null,
          // inputValue: this.user.bio,
          html: `
            <div class="col-12 input-group input-group-sm">
              <span class="input-group-prepend w-25">
                <span class="input-group-text w-100">Banco</span>
              </span>
              <select class="form-control form-control-sm custom-select custom-select-sm" name="bank" >
                <option value='Itaú'>Itaú</option>
                <option value='Bradesco'>Bradesco</option>
                <option value='Caixa Econômica'>Caixa Econômica</option>
                <option value='Banco do Brasil'>Banco do Brasil</option>
                <option value='Santander'>Santander</option>
                <option value='Banrisul'>Banrisul</option>
                <option value='Sicredi'>Sicredi</option>
                <option value='Sicoob'>Sicoob</option>
                <option value='Inter'>Inter</option>
                <option value='BRB'>BRB</option>
                <option value='Via Credi'>Via Credi</option>
                <option value='Neon'>Neon</option>
                <option value='Nubank'>Nubank</option>
                <option value='Pagseguro'>Pagseguro</option>
                <option value='Banco Original'>Banco Original</option>
                <option value='Safra'>Safra</option>
                <option value='Modal'>Modal</option>
                <option value='Banestes'>Banestes</option>
                <option value='Unicred'>Unicred</option>
              </select>
            </div>

            <div class="col-12 input-group input-group-sm">
              <span class="input-group-prepend w-25">
                <span class="input-group-text w-100">Nº Conta</span>
              </span>
              <input class="form-control form-control-sm" name="bank_cc" />
            </div>

            <div class="col-12 input-group input-group-sm">
              <span class="input-group-prepend w-25">
                <span class="input-group-text w-100">Agência</span>
              </span>
              <input class="form-control form-control-sm" name="bank_ag"/>
            </div>

            <div class="col-12 input-group input-group-sm">
              <span class="input-group-prepend w-25">
                <span class="input-group-text w-100">Tipo de Conta</span>
              </span>
              <select class="form-control form-control-sm custom-select custom-select-sm" name="account_type" >
                <option value="Corrente">Corrente</option>
                <option value="Poupança">Poupança</option>
              </select>
            </div>
          `,
          preConfirm: ( value ) => {
            let bank = {}
            bank.bank = $('select[name=bank]').val()
            bank.bank_cc = $('input[name=bank_cc]').val()
            bank.bank_ag = $('input[name=bank_ag]').val()
            bank.account_type = $('select[name=account_type]').val()

            if (
              bank.bank == ""
              || bank.bank_cc == ""
              || bank.bank_ag == ""
              || bank.account_type == ""
            ) {
              Swal.showValidationMessage(
                `Alguma coisa esta errada nos dados bancários`
              )
            } else {
              return bank
            }
          }
        }
      ]).then((result) => {
        console.log(result)
        // Axios.post(`/student/turn-into-teacher`, {
        //   user: this.user.id,
        //   document: result.value[0],
        //   bio: result.value[1],
        //   bank: result.value[2]
        // })
        //   .then( res => {

        //     this.$store.commit('SET_CURRENT_USER', {
        //       id: this.user.id,
        //       name: this.user.name,
        //       email: this.user.email,
        //       picture: this.user.picture,
        //       rank:  this.user.rank,
        //       type: "TCH"
        //     })

        //     Swal.fire({
        //       icon: 'success',
        //       title: 'Pronto!',
        //       text: 'Agora você é um instrutor Akdemica.',
        //       showConfirmButton: false,
        //       timer: 1500,
        //       backdrop: '#CC3300',
        //     })
        //   })
        //   .catch( err => {
        //     let message = ''

        //     let keys = Object.keys(err.response.data)

        //     keys.forEach((item) => {
        //       message += err.response.data[item] + '<br>'
        //     })

        //     Swal.fire({
        //       icon: 'error',
        //       title: 'Oops!',
        //       html: message,
        //       backdrop: '#CC3300',
        //     })
        //   })
      })
    }
  }
}
</script>
